/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Button from "@fdn/button";
import Modal from "@fdn/modal";
import Vars from "Consts/vars";

const Desktop = ({ ...props }) => {

	const prop = props;

	return (
		<div className="complete-profile-modal-container">
			<Modal
				is_mobile={prop.isMobile}
				show={prop.isShow}
				background_image={null}
				closable
				on_click={prop.onClickLater}
				width="400px"
			>
				<div className="complete-profile-cta-container">
					<div className="complete-profile-cta-top">
						<p className="complete-profile-percentage">
							{prop.percentage}
							{" "}
							Completed
						</p>
						<div className="progress-bar-container">
							<div className="progress-bar-fill" />
						</div>
						<p className="percentage-subtitle">
							{
								Vars.PERCENTAGE_SUBTITLE.filter((completing) => completing.percentage === prop.percentage).length > 0
								&& Vars.PERCENTAGE_SUBTITLE.filter((completing) => completing.percentage === prop.percentage)[0].subtitle
							}
						</p>
					</div>

					<div className="complete-profile-cta-bottom">
						<h3>{Vars.PRODUCT_MATCHES_POPUP.title}</h3>
						<p>{Vars.PRODUCT_MATCHES_POPUP.body_text}</p>
						<div className="button-wrapper">
							<Button
								id_element="complete-profile-cta-btn"
								variant="primary"
								border_radius="4px"
								on_click={prop.onClickCompleteProfile}
								block
							>
								COMPLETE MY PROFILE
							</Button>
							<Button
								id_element="do-it-later"
								variant="light"
								on_click={prop.onClickLater}
								block
							>
								I&#39;ll do it later
							</Button>
						</div>
					</div>
				</div>
			</Modal>

			<style>
				{`
					.complete-profile-modal-container .fdn-modal {
						width: 400px;
						padding: 0;
						border-radius: 8px;
					}

					.complete-profile-modal-container .fdn-modal-header {
						height: 0;
					}

					.complete-profile-modal-container .fdn-modal-header span {
						z-index: 2;
						font-weight: normal;
						top: 3px;
						right: 10px;
					}

					#complete-profile-cta-btn {
						font-family: Poppins;
						font-style: normal;
						font-weight: 600;
						font-size: 16px;
						line-height: 24px;
						color: #FFFFFF;
						max-width: 249px;
						margin: auto;
						height: 42px;
						padding: 6px 16px;
					}

					#do-it-later {
						font-family: 'Roboto';
						font-style: normal;
						font-weight: 400;
						font-size: 16px;
						line-height: 24px;
						text-align: center;
						color: #919EAB;
						margin-top: 10px;
					}

				`}
			</style>

			<style jsx>
				{`
					
					.complete-profile-cta-container {
						background: #FFFFFF;
						box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
						border-radius: 8px;
						box-sizing: border-box;
						text-align: center;
					}

					.complete-profile-cta-top {
						background: #FCEFF2;
						padding: 32px;
						position: relative;
						border-radius: 8px 8px 0px 0px;
					}

					.complete-profile-cta-top p {
						font-family: Roboto;
						font-style: normal;
						font-weight: 400;
						font-size: 20px;
						line-height: 22px;
						color: #323942;
						margin: 0;
					}

					.complete-profile-cta-top p.percentage-subtitle {
						font-family: Roboto;
						font-weight: 400;
						font-size: 14px;
						line-height: 22px;
						color: #323942;
					}

					.complete-profile-percentage {
						font-family: Poppins !important;
						font-weight: 600 !important;
						color: #000000 !important;
					}

					.progress-bar-container {
						background: #F0F3F7;
						border: 2px solid #FFFFFF;
						border-radius: 16px;
						height: 12px;
						margin: 16px 0;
					}

					.progress-bar-fill {
						background: linear-gradient(90deg, #F3BDCA 2.03%, #FFDF9D 100%);
						border-radius: 16px;
						height: 12px;
						width: ${prop.percentage};
					}

					.close-modal-btn {
						position: absolute;
						right: 15.25px;
						top: 15.25px;
						font-size: 20px;
						cursor: pointer;
					}

					.complete-profile-cta-bottom {
						padding: 24px 35px 8px;
					}

					.complete-profile-cta-bottom h3 {
						font-family: Poppins;
						font-style: normal;
						font-weight: 600;
						font-size: 16px;
						line-height: 24px;
						color: #000000;
						margin: 0;
						margin-bottom: 16px;
					}

					.complete-profile-cta-bottom p {
						font-family: Roboto;
						font-style: normal;
						font-weight: 400;
						font-size: 14px;
						line-height: 22px;
						color: #323942;
						margin: 0;
						margin-bottom: 23px;
					}

				`}
			</style>
		</div>
	);

};

export default Desktop;
